import Operation, { OperationIntent } from '../models/Operation';
import { calculateAmount } from '../random/utils';
import { Container } from '@ivorobioff/shared';
import { SavingService } from './SavingService';
import Saving from '../models/Saving';
import Debt from '../models/Debt';
import { DebtService } from './DebtService';

export default class SavingOperationService {
  private savingService: SavingService;
  private debtService: DebtService;

  constructor(container: Container) {
    this.savingService = container.get(SavingService);
    this.debtService = container.get(DebtService);
  }

  validate(saving: Saving, operation: Operation) {
    return calculateAmount(saving.amount, operation) < 0
      ? 'Result must be greater than, or equal to 0'
      : undefined
  }

  async submit(saving: Saving, operation: Operation): Promise<Saving> {
    const calculatedAmount = calculateAmount(saving.amount, operation);
    return this.savingService.updateAmountAsync(saving.id, {
      amount: calculatedAmount,
      note: operation.note,
      version: saving.version
    });
  }

  async borrow(saving: Saving, amount: number): Promise<{ saving: Saving; debt: Debt; }> {

    const debts = await this.debtService.getAllAsync();
    const matchedDebt = debts.find(debt => debt.name === saving.name);

    const debt = matchedDebt
      ? matchedDebt
      : await this.debtService.createAsync({
        name: saving.name,
        amount: 0
      });

    await this.debtService.updateAmountAsync(debt.id, {
      amount: calculateAmount(debt.amount, { intent: OperationIntent.Plus, amount }),
      note: `Borrowed - ${saving.name}`,
      version: debt.version,

    });

    saving = await this.savingService.updateAmountAsync(saving.id, {
      amount: calculateAmount(saving.amount, { intent: OperationIntent.Minus, amount }),
      note: `Borrowed - ${debt.name}`,
      version: saving.version
    });

    return {
      saving,
      debt
    };
  }
}